import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup'
import './summary.css'
import axios from 'axios';
import { Api } from '../../../services/api';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast'
import { useFormik } from 'formik';
import { set } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { BiCheck } from 'react-icons/bi';
import { Tooltip } from 'primereact/tooltip';
import { BsFillInfoCircleFill, BsInfoCircle } from 'react-icons/bs'; // Bootstrap Info Icon


const Summary = () => {
  const toast = useRef(null);
  const [projectionSummary, setProjectionSummary] = useState([]);
  const [ColumnName, setColumnName] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [summaryGoalsModal, setSummaryGoalsModal] = useState(false);
  // const [currentYear, setCurrentYear] = useState(2024);

  //const [summaryGoalsModal, setSummaryGoalsModal] = useState({ open: false, year: new Date().getFullYear() });
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());


  useEffect(() => {
    console.log('Fetching projects...');
    getProjectionSummary();

  }, []);

  const getProjectionSummary = async () => {

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    axios.get(Api.API_BASE_URL + 'get-financial-summary', { headers })
      .then((response) => {
        setIsLoading(false);
        setProjectionSummary(response.data.result);

        setColumnName(response.data.ColumnName)
      })
      .catch((error) => {
        // stop loader
        setIsLoading(false);
        console.error('Error fetching projects:', error);
      });
  }

  const headerClick = (data) => {
    if (data.endsWith(' Goals') || data === '2020' || data === '2021' || data === '2022') {
      const year = data.replace(' Goals', '');
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <span>{data}</span>
          <Button
            icon="pi pi-plus"
            style={{
              width: '24px',
              height: '24px',
              padding: '4px',
              fontSize: '14px',
              borderRadius: '50%',
              border: '1px solid lightgray',
              backgroundColor: 'white',
              color: '#6c757d', // Subtle gray color
              transition: '0.2s ease-in-out',
            }}
            className="custom-header-button"
            title="Edit Goals"
            onClick={(e) => {
              e.stopPropagation(); // Prevent accidental table sorting
              makeApiCall(year);
            }}
          />
        </div>
      );
    }
    return <span>{data}</span>;
  };
  
  const headerGroup = (
    <ColumnGroup>
      <Row>
        {/* First Column (Frozen) */}
        <Column 
          field={ColumnName[0]} 
          frozen 
          header={ColumnName[0]} 
          style={{ 
            width: '300px', 
            textAlign: 'left', 
            // padding: '8px', 
            height: '40px',
            // borderBottom: '1px solid gray', 
            // borderRight: '1px solid gray' 
          }} 
        />
  
        {/* Remaining Columns */}
        {ColumnName.slice(1).map((row, i) => (
          <Column 
            key={i + 1} 
            header={() => headerClick(row)} // Wrap in a function!
            style={{ 
              textAlign: 'center', 
              width: '150px', 
              // padding: '8px', 
              height: '40px',
              // backgroundColor: row === "Year" || row === "% of Sales" ? '#FFC000' : '#F8F9FA', 
              // borderBottom: '1px solid gray', 
              // borderRight: '1px solid gray' 
            }} 
          />
        ))}
      </Row>
    </ColumnGroup>
  );
  
  
  const makeApiCall = (year) => {
    var url = Api.API_BASE_URL + 'get-goal';

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ year: year }),
    })

      .then((response) => response.json())
      .then((data) => {
        var response = data.result;
        console.log(data);
        formik.setFieldValue('year', year);
        if (data.error != '') {
          setSummaryGoalsModal(true);
        } else {


          formik.setFieldValue('gross_sales', response.gross_sales);
          formik.setFieldValue('gross_profit', response.gross_profit);
          formik.setFieldValue('less_total_operating_expense', response.less_total_operating_expense);

          //* ------Added by Suraj -------------
          formik.setFieldValue('multi_family', response.multi_family);
          formik.setFieldValue('multi_family_revenue', response.multi_family_revenue);
          formik.setFieldValue('custom_home', response.custom_home);
          formik.setFieldValue('custom_home_revenue', response.custom_home_revenue);
          formik.setFieldValue('renovations', response.renovations);
          formik.setFieldValue('renovations_revenue', response.renovations_revenue);
          formik.setFieldValue('commercial', response.commercial);
          formik.setFieldValue('commercial_revenue', response.commercial_revenue);
          formik.setFieldValue('tenent_improvements', response.tenent_improvements);
          formik.setFieldValue('tenent_improvements_revenue', response.tenent_improvements_revenue);
          formik.setFieldValue('service_and_maintenance', response.service_and_maintenance);
          formik.setFieldValue('service_and_maintenance_revenue', response.service_and_maintenance_revenue);
          setSummaryGoalsModal(true);
        }

      })
      .catch((error) => {
        console.error(error);
      });
  };


  const formik = useFormik({
    initialValues: {
      gross_sales: '',
      gross_profit: '',
      less_total_operating_expense: '',
      multi_family: '',
      multi_family_revenue: '',
      custom_home: '',
      custom_home_revenue: '',
      renovations: '',
      renovations_revenue: '',
      commercial: '',
      commercial_revenue: '',
      tenent_improvements: '',
      tenent_improvements_revenue: '',
      service_and_maintenance: '',
      service_and_maintenance_revenue: '',

    },

    validate: (data) => {

    },

    onSubmit: (data) => {
      var url = Api.API_BASE_URL + 'save-goal ';
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
          } else {
            toast.current.show({ severity: 'success', summary: 'success', detail: Josn.result });
            setSummaryGoalsModal(false);
            getProjectionSummary();
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });

    }
  });

  const renderInputArea = (fieldName, title) => (
    <div className="col-6 p-2">
      <label className='text-gray-600 text-sm' >{title}</label>
      <InputNumber
        inputId={formik.values[fieldName] < 0 ? 'number-negataive-price' : 'currency-positive'}
        id={fieldName}
        name={fieldName}
        mode="currency" currency="USD" locale="en-US"
        value={formik.values[fieldName]}
        className={classNames('pt-1',)} style={{ width: '100%' }}
        onChange={(e) => {
          formik.setFieldValue(fieldName, e.value)
        }}
      />
    </div>
  );

  const renderInputTextArea = (fieldName, title) => (
    <div className="col-6 p-2">
      <label className='text-gray-600 text-sm' >{title}</label>
      <InputNumber
        // inputId={formik.values[fieldName] < 0 ? 'number-negataive-price' : 'currency-positive'}
        id={fieldName}
        name={fieldName}
        suffix=" %"
        // mode="currency" currency="USD" locale="en-US"
        value={formik.values[fieldName]}
        className={classNames('pt-1',)} style={{ width: '100%', height: '35px', padding: '0px' }}
        onChange={(e) => {

          formik.setFieldValue(fieldName, e.value)
        }}
      />
    </div>
  );

  const renderInputArea2 = (fieldName, title) => {

    console.log(fieldName);

    return (
      <div className="col-6 p-2">
        <label className='text-gray-600 text-sm ' >{title}</label>
        <InputNumber
          disabled
          inputId={fieldName < 0 ? 'number-negataive-price' : 'currency-positive'}
          id={fieldName}
          name={fieldName}
          mode="currency" currency="USD" locale="en-US"
          value={fieldName}
          style={{ width: '100%', backgroundColor: '#F8EED7', fontWeight: 'bold' }}
          onChange={(e) => {
            // formik.setFieldValue(fieldName, e.target.value)
          }}

        />
      </div>
    );
  }

  const renderInputArea3 = (fieldName, title) => (
    <div className="col-6 p-2">
      <label className='text-gray-600 text-sm ' >{title}</label>
      <InputNumber
        disabled
        inputId={fieldName < 0 ? 'number-negataive-price' : 'currency-positive'}
        id={fieldName}
        name={fieldName}
        suffix=" %"
        value={isNaN(fieldName) ? 0 : fieldName}
        style={{ width: '100%', backgroundColor: '#F8EED7', fontWeight: 'bold' }}
        onChange={(e) => {
          // formik.setFieldValue(fieldName, e.target.value)
        }}
      />
    </div>
  );
  const renderDecimalCell = (rowData, column) => {

    const value = rowData[column.field];

    if (value == null) {
      return '';
    }

    // console.log('Row Data: ' + JSON.stringify(rowData));

    if (rowData.Sales.toString().includes('%')) {
      if (value === "Gross Profit %:" || value === "% of Sales:") {
        return value
      }
      if (value == 0) {
        return '';
      }
      if (typeof value == 'number') {
        return `${value.toFixed(2)} %`;
      }
      return `${value}`;
      // return `${value.toFixed(2)} %`;
    }
    if (value == 0) {
      return '';
    }
    if (column.field === "Increase %") {
      return `${value.toFixed(2)} %`;

    }

    if (typeof value === 'number') {
      // Check if it's a percentage (ends with %)
      if (typeof value === 'string') {
        value = parseFloat(value);
      }
      if (value < 0) {
        return <div style={{ 
          color: 'red', 
          // backgroundColor: '#fcd9d9', 
          height: '36px', 
          paddingTop: "8px", 
          // border: '1px solid red' 
        }} > 
        
        {formatCurrency(value)}</div>
      }

      // Display the number with a $ sign and a maximum of two decimal places
      return formatCurrency(value);
    }

    return value;
  };
  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };

  // Your component logic
  // const rowClass = (data) => {
  //   // Projects
  //   return {
  //     'bg-yellow-300': data['Sales'] === '2022 Projected Cash Flow Summary:' || data['Sales'] === '',
  //     'bg-gray-400': data['Sales'] === 'Revenue Projection' || data['Sales'] === 'Sales' || data['Sales'] === 'Projections and Assumption' ||data['Sales'] === 'Total' || data['Sales'] === 'Grand Total' || data['Sales'] === 'Total Projecs % of revenue',
  //     'bg-gray-200': data['Sales'] === 'POC' || data['Sales'] === 'OTHER' || data['Sales'] === 'POC & OTHER %',
  //   };
  // };

  const rowClass = (data) => {
    if (data['Sales'] === 'Revenue Projection' || data['Sales'] === 'Sales' || data['Sales'] === 'Projections and Assumption' || data['Sales'] === 'Total' || data['Sales'] === 'Grand Total' || data['Sales'] === 'Total Projects % of revenue') {
      return 'bg-gray-200';
    }
    return '';
  };  

  // const renderTooltipCell = (rowData, column) => {
  //   const tooltipId = `tooltip-${(rowData.id || Math.random().toString(36).substr(2, 9))}`; // Ensures a valid ID
  
  //   return (
  //     <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
  //       <span>{rowData[column.field]}</span>
  //       <BsFillInfoCircleFill id={tooltipId} className='text-gray-500 hover:text-gray-900'  />
  //       <Tooltip 
  //         target={`#${tooltipId}`} 
  //         // content={rowData[column.field]} 
  //         content={rowData['Tooltip']} 
  //         position="top" 
  //         className="custom-tooltip"
  //       />
  //     </div>
  //   );

  // };

  const renderTooltipCell = (rowData, column) => {
    const tooltipId = `tooltip-${(rowData.id || Math.random().toString(36).substr(2, 9))}`; // Ensures a valid ID
    const hasTooltip = !!rowData['Tooltip']; // Check if there is a tooltip value
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <span>{rowData[column.field]}</span>
  
        {hasTooltip && (
          <>
            <BsFillInfoCircleFill
              id={tooltipId}
              className='text-gray-500 hover:text-gray-900'
            />
            <Tooltip
              target={`#${tooltipId}`}
              content={rowData['Tooltip']}
              position="top"
              className="custom-tooltip"
            />
          </>
        )}
      </div>
    );
  };
  

  return (
    <>
      <Toast ref={toast} />
      <div className=''>

        <div>
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="dataTableSummery p-2">
              {/* <DataTable
                value={projectionSummary}
                showGridlines
                headerColumnGroup={headerGroup}
                selectionMode="single"
                selection={selectedProduct}
                rowClassName={rowClass}
                onSelectionChange={(e) => setSelectedProduct(e.value)}
                tableStyle={{ tableLayout: 'fixed', minWidth: '90vw', minHeight: '500px', borderCollapse: 'separate', borderSpacing: '0', }}
                scrollable
                scrollHeight="flex"
                stripedRows
                size="small"
                className='financial-summary-datatble'
              >

                {ColumnName.map((row, i) => (
                  <Column
                    key={i}
                    field={row}
                    body={renderDecimalCell}


                    style={{ textAlign: i === 0 ? 'left' : 'center', borderRight: '1px solid gray', height: '27px', minWidth: '150px'}}
                    frozen={i === 0}
                  />

                ))}
              </DataTable> */}

              <DataTable
                value={projectionSummary}
                // showGridlines
                headerColumnGroup={headerGroup}
                selectionMode="single"
                selection={selectedProduct}
                rowClassName={rowClass}
                onSelectionChange={(e) => setSelectedProduct(e.value)}
                tableStyle={{ tableLayout: 'fixed', minWidth: '90vw', minHeight: '500px', borderCollapse: 'separate', borderSpacing: '0' }}
                scrollable
                scrollHeight="flex"
                // stripedRows
                size="small"
                className='financial-summary-datatble'
              >
                {ColumnName.map((row, i) => (
                  <Column
                    key={i}
                    field={row}
                    body={i === 0 ? renderTooltipCell : renderDecimalCell} // Apply tooltip only on the first column
                    style={{ textAlign: i === 0 ? 'left' : 'center', height: '30px', minWidth: '100px'}} //borderRight: '1px solid gray'
                    frozen={i === 0}
                  />
                ))}
              </DataTable>              

              <Dialog header={"Goals"} headerClassName="centered-header" visible={summaryGoalsModal} maximizable style={{ width: '40vw' }} dismissableMask="true" onHide={() => { setSummaryGoalsModal(false); }}>
                <div className=''>
                  <form className="m-5 mt-0 mb-0" onSubmit={formik.handleSubmit} >
                    <div className=" formgrid grid">

                      {renderInputArea('gross_sales', 'Gross Sales')}
                      {renderInputArea('gross_profit', 'Gross Profit')}
                      {/* {renderInputArea3(Number(formik.values.gross_sales) / Number(formik.values.gross_profit), 'Gross Profit %')} */}
                      {renderInputArea3(
                        Number(formik.values.gross_profit) && Number(formik.values.gross_sales)
                          ? (Number(formik.values.gross_profit) / Number(formik.values.gross_sales)) * 100
                          : 0,
                        'Gross Profit %'
                      )}
                      {renderInputArea('less_total_operating_expense', 'Less Total Operating Expense')}



                      {renderInputArea3(
                        Number(formik.values.less_total_operating_expense) && Number(formik.values.gross_sales)
                          ? (Number(formik.values.less_total_operating_expense) / Number(formik.values.gross_sales)) * 100
                          : 0,
                        '% of Sales'
                      )}
                      {renderInputArea2(
                        Number(formik.values.less_total_operating_expense) && Number(formik.values.gross_sales) && Number(formik.values.gross_profit)
                          ? (Number(formik.values.less_total_operating_expense) / (Number(formik.values.gross_sales) / Number(formik.values.gross_profit))) * 100
                          : 0,
                        'Break Even Point'
                      )}

                      {renderInputArea2(
                        Number(formik.values.gross_profit) - Number(formik.values.less_total_operating_expense) || 0,
                        'Net Profit/Loss'
                      )}

                      {renderInputArea3(
                        Number(formik.values.gross_profit) && Number(formik.values.less_total_operating_expense) && Number(formik.values.gross_sales)
                          ? ((Number(formik.values.gross_profit) - Number(formik.values.less_total_operating_expense)) / Number(formik.values.gross_sales)) * 100
                          : 0,
                        '% of Sales'
                      )}

                      {renderInputArea('multi_family', 'LIDA Multi Family Projects')}
                      {renderInputTextArea('multi_family_revenue', 'LIDA Multi Family Projects % of revenue')}
                      {renderInputArea('custom_home', 'Custom Homes Projects')}
                      {renderInputTextArea('custom_home_revenue', 'Custom Homes Projects % of revenue')}
                      {renderInputArea('renovations', 'Renovations Projects')}
                      {renderInputTextArea('renovations_revenue', 'Renovations Projects % of revenue')}
                      {renderInputArea('commercial', 'Commercial Projects')}
                      {renderInputTextArea('commercial_revenue', 'Commercial Projects % of revenue')}
                      {renderInputArea('tenent_improvements', 'Tenent Improvements Projects')}
                      {renderInputTextArea('tenent_improvements_revenue', 'Tenent Improvement Projects % of revenue')}
                      {renderInputTextArea('service_and_maintenance', 'Service & Maintenance Projects')}
                      {renderInputTextArea('service_and_maintenance_revenue', 'Service & Maintenance Projects % of revenue')}



                      <div className="w-full flex mt-5" style={{ justifyContent: 'center' }}>
                        <button type="submit" title='Save' style={{ cursor: 'pointer' }} className="customSave-button m-2" >
                          <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center' }}>
                            <BiCheck size={20} />
                            <span> SAVE </span>
                          </div>
                        </button>
                      </div>

                    </div>

                  </form>

                </div>
              </Dialog>
              
            </div>
          )}
        </div>
      </div>



    </>
  );
}

export default Summary;
